import { render, staticRenderFns } from "./OfflineDetail.vue?vue&type=template&id=68b93187&scoped=true"
import script from "./OfflineDetail.vue?vue&type=script&lang=js"
export * from "./OfflineDetail.vue?vue&type=script&lang=js"
import style0 from "./OfflineDetail.vue?vue&type=style&index=0&id=68b93187&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b93187",
  null
  
)

export default component.exports